import React from "react";
export const RedStar: React.FC = () => <span style={{ color: "red", position: "relative", bottom: "10px", right: "5px" }}>*</span>;